<template>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn icon x-small v-on="on" @click.stop>
        <v-icon small>add</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item @click="$emit('createFolder')">
        <v-list-item-action>
          <v-icon>folder</v-icon>
        </v-list-item-action>
        <v-list-item-title>New Folder</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$emit('createContext')">
        <v-list-item-action>
          <v-icon>list_alt</v-icon>
        </v-list-item-action>
        <v-list-item-title>New Context</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {};
</script>

<style></style>
